import {
  exportAndDownloadAuditEvents,
  purgeAuditEvents,
} from '../services/audit/auditAdmin';

/** God-only audit export / purge actions for the audit screen. */
export function useAuditAdmin() {
  return {
    exportEvents: exportAndDownloadAuditEvents,
    purgeEvents: purgeAuditEvents,
  };
}
